(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["celociel-emberglow-offers"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('celociel-emberglow-offers')){
  customElements.define('celociel-emberglow-offers',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;
      this.ready=true;
      this.config=JSON.parse(this.querySelector('[data-config]').textContent);
      this.form=this.querySelector('form');
      this.colour=this.querySelector('select');
      this.button=this.querySelector('[data-add]');
      this.error=this.querySelector('[data-error]');
      this.money=new Intl.NumberFormat(this.dataset.locale,{style:'currency',currency:this.dataset.currency});
      if(!this.config.six.available){this.querySelector('input[value="single"]').checked=true;}
      this.form.addEventListener('change',e=>{this.update();if(e.target===this.colour)this.updateMedia();});
      this.form.addEventListener('submit',e=>this.add(e));
      this.update();
    }
    amount(cents){return this.money.format(cents/100);}
    update(){
      const variant=this.config.variants[this.colour.value];
      this.choice=this.querySelector('input[type="radio"]:checked').value;
      for(const key of ['single','four','six']){
        const oil=key==='single'?null:this.config[key];
        const total=variant.price+(oil?oil.price-oil.save:0);
        this.querySelector(`[data-price="${key}"]`).textContent=this.amount(total);
        if(oil)this.querySelector(`[data-separate="${key}"]`).textContent=this.config.labels.separate.replace('__AMOUNT__',this.amount(variant.price+oil.price));
      }
      const oil=this.choice==='single'?null:this.config[this.choice];
      this.querySelector('[data-oil-id]').disabled=!oil;
      this.querySelector('[data-oil-quantity]').disabled=!oil;
      if(oil)this.querySelector('[data-oil-id]').value=oil.id;
      this.total=variant.price+(oil?oil.price-oil.save:0);
      this.querySelector('[data-total]').textContent=this.amount(this.total)+' '+this.dataset.currency;
      this.button.disabled=!variant.available||(oil&&!oil.available);
      this.button.textContent=this.button.disabled?this.config.labels.unavailable:this.config.labels[this.choice];
    }
    updateMedia(){
      const variant=this.config.variants[this.colour.value];
      const section=document.getElementById('shopify-section-'+this.dataset.section);
      const gallery=section?.querySelector('media-gallery');
      if(variant.media&&typeof gallery?.setActiveMedia==='function')gallery.setActiveMedia(this.dataset.section+'-'+variant.media,true);
      const url=new URL(location.href);url.searchParams.set('variant',this.colour.value);history.replaceState({},'',url);
    }
    async add(event){
      event.preventDefault();
      if(this.busy||this.button.disabled)return;
      this.busy=true;this.button.disabled=true;this.button.textContent=this.config.labels.adding;this.error.hidden=true;
      const items=[{id:Number(this.colour.value),quantity:1}];
      if(this.choice!=='single')items.push({id:this.config[this.choice].id,quantity:1});
      try{
        const root=this.dataset.root.endsWith('/')?this.dataset.root:this.dataset.root+'/';
        const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
        const result=await response.json();
        if(!response.ok||result.status)throw new Error(result.description||this.config.labels.error);
        location.assign(this.dataset.cart);
      }catch(error){this.error.textContent=error.message||this.config.labels.error;this.error.hidden=false;this.busy=false;this.update();}
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["celociel-pair-check"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('celociel-pair-check')) {
  customElements.define('celociel-pair-check', class extends HTMLElement {
    connectedCallback() {
      this.control = new AbortController();
      this.variants = JSON.parse(this.querySelector('script').textContent);
      this.root = this.closest('product-info');
      if (!this.root) return;
      this.message = this.querySelector('[role="alert"]');
      const options = {capture: true, signal: this.control.signal};
      this.root.addEventListener('change', () => queueMicrotask(() => this.validate()), options);
      this.root.addEventListener('submit', event => {
        if (!this.validate()) { event.preventDefault(); event.stopImmediatePropagation(); this.message.scrollIntoView({block:'center'}); }
      }, options);
      this.root.addEventListener('click', event => {
        if (event.target.closest('button[type="submit"]') && !this.validate()) {
          event.preventDefault(); event.stopImmediatePropagation(); this.message.scrollIntoView({block:'center'});
        }
      }, options);
    }
    disconnectedCallback() { this.control?.abort(); }
    validate() {
      const selected = this.root.querySelector('lumin-product-qty-break input[type="radio"]:checked');
      if (!selected) { this.message.hidden = true; return true; }
      const rows = selected.closest('lumin-product-qty-break').querySelectorAll('.lumin-product-block-qty-break-variant-options');
      let valid = true;
      rows.forEach(row => {
        const selects = [...row.querySelectorAll('select')];
        const values = selects.map(select => select.value);
        const match = this.variants.find(variant => variant.available && variant.options.every((value,index) => value === values[index]));
        selects.forEach(select => select.setAttribute('aria-invalid', match ? 'false' : 'true'));
        if (!match) valid = false;
      });
      this.message.hidden = valid;
      return valid;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cloudnest-pair"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cloudnest-pair')) {
    customElements.define('cloudnest-pair', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        const form = this.querySelector('form');
        if (!form) return;
        this.ready = true;
        this.cards = Array.from(this.querySelectorAll('.cn-offers__card'));
        this.button = this.querySelector('.cn-offers__add');
        this.error = this.querySelector('[role="alert"]');
        this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {style:'currency',currency:this.dataset.currency || 'GBP',currencyDisplay:'code'});
        this.cards.forEach((card,index) => {
          card.querySelector('input[type="radio"]').addEventListener('change',()=>this.activate(index));
          card.querySelectorAll('select').forEach(select=>select.addEventListener('change',()=>{this.updatePrice(card);this.error.hidden=true;}));
        });
        this.activate(0);
        form.addEventListener('submit',async(event)=>{
          event.preventDefault();
          if(this.busy)return;
          const selections=Array.from(this.cards[this.selected].querySelectorAll('select'));
          if(selections.some(s=>!s.selectedOptions[0] || s.selectedOptions[0].disabled)){this.error.textContent=this.dataset.error;this.error.hidden=false;return;}
          const quantities=new Map();
          selections.forEach(select=>{const id=Number(select.value);quantities.set(id,(quantities.get(id)||0)+1);});
          const items=Array.from(quantities,([id,quantity])=>({id,quantity}));
          const label=this.button.textContent;
          this.busy=true;this.button.disabled=true;this.button.textContent=this.dataset.adding;this.error.hidden=true;
          try {
            const response=await fetch(this.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
            const result=await response.json();
            if(!response.ok)throw new Error(typeof result.description==='string'?result.description:this.dataset.error);
            window.location.assign(this.dataset.cartUrl);
          } catch(failure) {
            this.error.textContent=failure.message||this.dataset.error;this.error.hidden=false;this.button.textContent=label;this.button.disabled=false;this.busy=false;
          }
        });
      }
      activate(index) {
        this.selected=index;
        this.cards.forEach((card,i)=>{
          card.classList.toggle('is-selected',i===index);
          card.querySelector('input[type="radio"]').checked=i===index;
          const choices=card.querySelector('fieldset');choices.hidden=i!==index;choices.disabled=i!==index;
          this.updatePrice(card);
        });
        this.button.textContent=index===0?this.dataset.singleLabel:index===1?this.dataset.pairLabel:this.dataset.fourLabel;
        this.error.hidden=true;
      }
      updatePrice(card) {
        const selections=Array.from(card.querySelectorAll('select')).map(s=>s.selectedOptions[0]);
        const prices=selections.map(option=>Number(option.dataset.price));
        const original=prices.reduce((a,b)=>a+b,0);
        const rate=Number(card.dataset.discount);
        const total=prices.reduce((a,p)=>a+p-Math.floor(p*rate/100),0);
        card.querySelector('.cn-offers__total').textContent=this.money.format(total/100);
        const was=card.querySelector('.cn-offers__was');if(was)was.textContent=this.money.format(original/100);
        const image=card.querySelector('img');
        if(image && selections[0].dataset.image){image.src=selections[0].dataset.image;image.removeAttribute('srcset');}
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quiet-hours-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('quiet-hours-offer')) {
    customElements.define('quiet-hours-offer', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        const form = this.querySelector('form');
        if (!form) return;
        this.ready = true;
        this.cards = Array.from(this.querySelectorAll('.qh-offers__card'));
        this.button = this.querySelector('.qh-offers__add');
        this.error = this.querySelector('[role="alert"]');
        this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {style:'currency',currency:this.dataset.currency || 'GBP',currencyDisplay:'code'});
        this.cards.forEach((card,index) => {
          card.querySelector('input[type="radio"]').addEventListener('change',()=>this.activate(index));
          card.querySelectorAll('select').forEach(select=>select.addEventListener('change',()=>{this.updatePrice(card);this.error.hidden=true;}));
        });
        this.activate(0);
        form.addEventListener('submit',async(event)=>{
          event.preventDefault();
          if(this.busy)return;
          const selections=Array.from(this.cards[this.selected].querySelectorAll('select'));
          if(selections.some(s=>!s.selectedOptions[0] || s.selectedOptions[0].disabled)){this.error.textContent=this.dataset.error;this.error.hidden=false;return;}
          const quantities=new Map();
          selections.forEach(select=>{const id=Number(select.value);quantities.set(id,(quantities.get(id)||0)+1);});
          const items=Array.from(quantities,([id,quantity])=>({id,quantity}));
          const label=this.button.textContent;
          this.busy=true;this.button.disabled=true;this.button.textContent=this.dataset.adding;this.error.hidden=true;
          try {
            const response=await fetch(this.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
            const result=await response.json();
            if(!response.ok)throw new Error(typeof result.description==='string'?result.description:this.dataset.error);
            window.location.assign(this.dataset.cartUrl);
          } catch(failure) {
            this.error.textContent=failure.message||this.dataset.error;this.error.hidden=false;this.button.textContent=label;this.button.disabled=false;this.busy=false;
          }
        });
      }
      activate(index) {
        this.selected=index;
        this.cards.forEach((card,i)=>{
          card.classList.toggle('is-selected',i===index);
          card.querySelector('input[type="radio"]').checked=i===index;
          const choices=card.querySelector('fieldset');choices.hidden=i!==index;choices.disabled=i!==index;
          this.updatePrice(card);
        });
        this.button.textContent=index===0?this.dataset.singleLabel:index===1?this.dataset.pairLabel:this.dataset.fourLabel;
        this.error.hidden=true;
      }
      updatePrice(card) {
        const selections=Array.from(card.querySelectorAll('select')).map(s=>s.selectedOptions[0]);
        const prices=selections.map(option=>Number(option.dataset.price));
        const original=prices.reduce((a,b)=>a+b,0);
        const rate=Number(card.dataset.discount);
        const total=prices.reduce((a,p)=>a+p-Math.floor(p*rate/100),0);
        card.querySelector('.qh-offers__total').textContent=this.money.format(total/100);
        const was=card.querySelector('.qh-offers__was');if(was)was.textContent=this.money.format(original/100);
        const image=card.querySelector('img');
        if(image && selections[0].dataset.image){image.src=selections[0].dataset.image;image.removeAttribute('srcset');}
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
